import { render, staticRenderFns } from "./FaultEdit.vue?vue&type=template&id=785cafc0&scoped=true"
import script from "./FaultEdit.vue?vue&type=script&lang=js"
export * from "./FaultEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785cafc0",
  null
  
)

export default component.exports